import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GenreCard, EmptyState } from "@/components/cards";

export default function Genres() {
  const [genres, setGenres] = useState([]);
  useEffect(() => { api.get("/genres").then((r) => setGenres(r.data)); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10 fade-in">
      <h1 className="text-4xl md:text-5xl font-display font-bold">Genres</h1>
      <p className="text-muted-foreground mt-2">Every mood, every world. Find your next obsession by genre.</p>
      {genres.length ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {genres.map((g) => <GenreCard key={g.id} genre={g} />)}
        </div>
      ) : <div className="mt-10"><EmptyState title="No genres yet" subtitle="Genres will appear here once added in the CMS." /></div>}
    </div>
  );
}
